var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "64956ed1c835f4d9d6342f422d7cdbfc5b6f72c4"
};